import { Box, Stack, Typography } from '@mui/material';

import { useFormSectionStore } from '@src/store';

export const TabLabelText = ({
	label,
	subLabel,
	active,
	disabled,
}: {
	label: string;
	subLabel?: string;
	active: boolean;
	disabled: boolean;
}) => {
	return (
		<Stack pl={1}>
			<Typography
				color={disabled ? 'text.disabled' : active ? 'text.interactive' : 'text.secondary'}
				sx={{ textAlign: 'left', textTransform: 'none' }}
			>
				{label}
			</Typography>
			<Typography sx={{ textTransform: 'none', textAlign: 'left' }} variant="caption">
				{subLabel}
			</Typography>
		</Stack>
	);
};

export const handleTabSelection = (_event = {}, selectedIndex: number) => {
	try {
		useFormSectionStore.getState().setActiveSection(selectedIndex);
	} catch (e) {
		if (e instanceof Error) {
			console.error(e.message);
		}
	}
};

export const NodeIndexIndicator = ({ index, active }: { index: number; active: boolean }) => {
	return (
		<Box
			sx={{
				backgroundColor: active ? 'secondary.main' : 'neutrals.disabled',
				color: '#FFF',
				padding: '.3rem .5rem',
				borderRadius: '1rem',
			}}
		>
			{index}
		</Box>
	);
};
export const makeTestIdForTabLink = (sectionName: string) => {
	return `${sectionName.replace(/ /g, '-').toLowerCase()}-tab-link`;
};
